export default {"src":"/_next/static/media/assign1.4b90c2ce.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};